import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A1F44] text-white/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="font-display text-xl text-white font-bold tracking-tight">
              Specialists<span className="text-[#3B82F6]">.no</span>
            </div>
            <p className="mt-4 text-sm text-white/60 leading-relaxed">
              Finn riktig spesialist — raskt og trygt. Kun klinikker med 4+ stjerner.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white font-semibold mb-4">Utforsk</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/behandlinger/estetikk-og-kosmetikk" className="hover:text-white">Behandlinger</Link></li>
              <li><Link to="/priser" className="hover:text-white">Priser</Link></li>
              <li><Link to="/artikler" className="hover:text-white">Artikler</Link></li>
              <li><Link to="/klinikker" className="hover:text-white">Klinikker</Link></li>
              <li><Link to="/sok" className="hover:text-white">Søk</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white font-semibold mb-4">Om</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/om-oss" className="hover:text-white">Om oss</Link></li>
              <li><Link to="/slik-fungerer-det" className="hover:text-white">Slik fungerer det</Link></li>
              <li><Link to="/for-klinikker" className="hover:text-white">For klinikker</Link></li>
              <li><Link to="/personvern" className="hover:text-white">Personvern</Link></li>
              <li><Link to="/cookies" className="hover:text-white">Cookies</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white font-semibold mb-4">Kontakt</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="mailto:kontakt@specialists.no" className="hover:text-white">kontakt@specialists.no</a></li>
            </ul>
            <div className="mt-6 text-xs text-white/50 leading-relaxed">
              Vi samarbeider kun med private klinikker med dokumentert høy rating. Tjenesten er gratis og uforpliktende for pasienter.
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-3">
          <span>© 2025 Specialists.no — Alle rettigheter forbeholdt</span>
          <span>Organisasjonsnr. 000 000 000</span>
        </div>
      </div>
    </footer>
  );
}
